import { ManageLocationsSections } from '@src/components/layout/admin/sections/manage-locations';
import { Profile } from '@src/utils/state-profile';

const ManageLocationsPage = () => {
    const profile = Profile();
    return <ManageLocationsSections isPrivate={profile?.role === 'EVENT_MANAGER' ? true : false} />;
};

export default ManageLocationsPage;
